import { Shark } from "shark-mvc";
// import { NousCore } from "nouscore-js-api";

import ManagerBase from "./ManagerBase";

class PlaceContentManager extends ManagerBase {
	constructor () {
		super("placeContentManager");
		this.remoteClassName = "place-content";
	}
}

const placeContentManager = new PlaceContentManager();

Shark.registerController(placeContentManager);

export default placeContentManager;
